import { render, staticRenderFns } from "./PuzzleOptionArrowsModal.vue?vue&type=template&id=62536b3d&scoped=true"
import script from "./PuzzleOptionArrowsModal.vue?vue&type=script&lang=js"
export * from "./PuzzleOptionArrowsModal.vue?vue&type=script&lang=js"
import style0 from "./PuzzleOptionArrowsModal.vue?vue&type=style&index=0&id=62536b3d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62536b3d",
  null
  
)

export default component.exports